export default "__VITE_ASSET__PKN7jgpY__"